import { InboxListComponent } from './../inboxList/inboxList.component';
import { InboxService } from './../../../services/InboxService.service';
import { InboxMessage } from './../InboxInterfaces/inboxMessage';
import { Component, HostListener, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-inboxMessage',
  templateUrl: './inboxMessage.component.html',
  styleUrls: ['./inboxMessage.component.less']
})
export class InboxMessageComponent implements OnInit {
  @Input() isDrawer = false;
  @Input() message: InboxMessage = {
    Code: '',
    DataParams: '',
    ROW: '',
    ROW1: '',
    RecDate: '',
    RecTime: '',
    Starred: '',
    Subject: '',
    U_NAME: '',
    WasRead: ''
  };
  @Output() callUpdate = new EventEmitter();
  @Output() collapse = new EventEmitter();
  public innerWidth: any;
  sharedMessageId: string;
  messageIdSubscription: Subscription;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }
  constructor(
    private inboxService: InboxService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.innerWidth = window.innerWidth;
  }

  ngOnInit() {
    this.messageIdSubscription = this.inboxService.currentMessageId.subscribe(messageId => {
      this.sharedMessageId = messageId;
    });
  }

  removeFromString(str: string) {
    const newStr = str.replace('<span class="msg-subject">', '').replace('</span>', '');
    return newStr;
  }

  changeStarringStatues(code, starred) {
    this.inboxService.StarringMessage(this.message.Code, this.message.Starred).subscribe(() => {
      this.callUpdate.next();
    });
  }
  openMessageDetails(code) {


    if (this.isDrawer === false) {
      this.router.navigate(['Details/' + code], { relativeTo: this.route, queryParamsHandling: 'merge' }).then(() => {
        if (this.innerWidth < 992) {
          this.collapse.next();
        }
      });
    }
  }
}
